module.exports = __webpack_public_path__ + "img/build_comment_answer.d3630fb9.jpg";